export default "__VITE_ASSET__B_nPBWmh__"